"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var oauth_1 = require("../routes/oauth");
var fetch_1 = require("../utils/fetch");
var transform_1 = require("../utils/transform");
var index_1 = require("../index");
exports.default = {
    sendVerification: function (phoneNumber) {
        var _a = oauth_1.default.verification, url = _a.url, method = _a.method;
        return fetch_1.default(url, {
            method: method,
            body: JSON.stringify({
                phone: phoneNumber.toString() || "",
            }),
        });
    },
    login: function (loginInput) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, url, method, body, result, date, enhancedToken;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = oauth_1.default.login, url = _a.url, method = _a.method;
                    body = transform_1.toSnakeCase(loginInput);
                    return [4, fetch_1.default(url, {
                            method: method,
                            body: JSON.stringify(body),
                        })];
                case 1:
                    result = _b.sent();
                    if (!result.status && !result.response) {
                        date = new Date();
                        date.setSeconds(date.getSeconds() + result.expiresIn);
                        enhancedToken = __assign(__assign({}, result), { dateOfExpiration: date.toISOString() });
                        return [2, index_1.default.restoreUserToken(enhancedToken)];
                    }
                    return [2, result];
            }
        });
    }); },
    logout: function (removeAll) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, url, method;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = oauth_1.default.logout, url = _a.url, method = _a.method;
                    return [4, fetch_1.default(url, {
                            method: method,
                            body: JSON.stringify({
                                remove_all: removeAll,
                            }),
                        })];
                case 1:
                    _b.sent();
                    index_1.default.restoreUserToken(null);
                    return [2];
            }
        });
    }); },
    exchangeV1Token: function (token) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, url, method, result, date, enhancedToken;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = oauth_1.default.exchangeOldToken, url = _a.url, method = _a.method;
                    return [4, fetch_1.default(url, {
                            method: method,
                            body: JSON.stringify({ token: token }),
                        })];
                case 1:
                    result = _b.sent();
                    if (!result.status && !result.response) {
                        date = new Date();
                        date.setSeconds(date.getSeconds() + result.expiresIn);
                        enhancedToken = __assign(__assign({}, result), { dateOfExpiration: date.toISOString() });
                        return [2, index_1.default.restoreUserToken(enhancedToken)];
                    }
                    return [2, result];
            }
        });
    }); },
};
//# sourceMappingURL=oauth.js.map